/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting import..." |
*
* @param {Iconik_Import_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_starting = /** @type {((inputs?: Iconik_Import_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de l'importation...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio importazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало импорта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando importación...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导入...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a importação...")
	return /** @type {LocalizedString} */ ("Starting import...")
});